import React, { FunctionComponent } from 'react'
import { Descriptions, Tag, Typography } from 'antd'
import { Link, useLoaderData, useMatch } from '@tanstack/react-router'

const VehicleDetails: FunctionComponent<any> = () => {
  const match = useMatch({ strict: false })
  const { vehicles, vehicleTypes, agencies } = useLoaderData({ from: match.routeId ?? '/' })

  const vehicle = vehicles[0]
  const vehicleType = vehicleTypes.find((vehicleType: any) => vehicleType.id === vehicle.vehicle_type_id)
  const agency = agencies.find((agency: any) => agency.id === vehicle.agency_id)

  return (
    <Descriptions title={'Vehicle Data'} column={1}>
      <Descriptions.Item label={'Vehicle ID'}>
        <Typography.Text>{vehicle?.vehicle_id}</Typography.Text>
      </Descriptions.Item>

      <Descriptions.Item label={'Asset ID'}>
        <Typography.Text>{vehicle?.asset_id}</Typography.Text>
      </Descriptions.Item>

      <Descriptions.Item label={'Name'}>
        <Typography.Text>{vehicle?.name}</Typography.Text>
      </Descriptions.Item>

      <Descriptions.Item label={'Vehicle Category'}>
        <Typography.Text>{vehicle?.vehicle_category_id}</Typography.Text>
      </Descriptions.Item>

      <Descriptions.Item label={'Vehicle Type'}>
        <Typography.Text>{vehicleType?.name}</Typography.Text>
      </Descriptions.Item>

      <Descriptions.Item label={'Agency'}>
        <Typography.Text>
          <Link to={`/admin/agencies/${agency?.id}`}>{agency?.name}</Link>
        </Typography.Text>
      </Descriptions.Item>

      <Descriptions.Item label={'Created by Feed'}>
        <Tag color={vehicle?.active_manage ? 'green' : 'red'}>{vehicle?.feed_created ? 'Yes' : 'No'}</Tag>
      </Descriptions.Item>

      <Descriptions.Item label={'Active Manage'}>
        <Tag color={vehicle?.active_manage ? 'green' : 'red'}>
          {vehicle?.active_manage ? 'Active' : 'Disabled'}
        </Tag>
      </Descriptions.Item>

      <Descriptions.Item label={'Active'}>
        <Tag color={vehicle?.active ? 'green' : 'red'}>{vehicle?.active ? 'Active' : 'Disabled'}</Tag>
      </Descriptions.Item>
    </Descriptions>
  )
}

export default VehicleDetails
